import { utilsGetLocalStorage } from "./utilsUpdateLocalStorage";

const isViewerMode = () => {
  const tlb = window?.objInit?.tlb;
  return tlb != null && tlb?.privacy_policy_consent === true;
};

export const shouldShowEmbeddedContent = () => {
  if (!isViewerMode()) {
    return true;
  }
  
  const localStorageCookieStatus = utilsGetLocalStorage("cookiesPrivacy");
  const sessionCookieStatus = window?.objInit?.session?.cookie_status;
  const cookieStatus = localStorageCookieStatus || sessionCookieStatus;
  
  return cookieStatus === "accepted_all" || cookieStatus === "acceptAll";
};

export const getCookieConsentStatus = () => {
  const localStorageCookieStatus = utilsGetLocalStorage("cookiesPrivacy");
  const sessionCookieStatus = window?.objInit?.session?.cookie_status;
  return localStorageCookieStatus || sessionCookieStatus || null;
};

